import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[resizeColumn]',
  standalone: false
})
export class ResizeColumnDirective implements OnInit {
  @Input() resizeColumn: any;
  @Input() index: number = 0;
  
  private startX: number = 0;
  private startWidth: number = 0;
  private resizer: HTMLElement | null = null;
  private isResizing: boolean = false;
  private headerElement: HTMLElement;
  
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.headerElement = this.el.nativeElement;
  }

  ngOnInit() {
    this.resizer = this.renderer.createElement('div');
    this.renderer.addClass(this.resizer, 'resizer');
    
    this.renderer.appendChild(this.headerElement, this.resizer);
    
    this.renderer.setStyle(this.headerElement, 'position', 'relative');
    
    if (this.resizer) {
      this.renderer.listen(this.resizer, 'mousedown', (event) => this.onMouseDown(event));
    }
  }
  
  private onMouseDown(event: MouseEvent) {
    event.preventDefault();
    
    this.startX = event.pageX;
    this.startWidth = this.headerElement.offsetWidth;
    this.isResizing = true;
    
    const mouseMoveListener = this.renderer.listen('document', 'mousemove', (e) => this.onMouseMove(e));
    const mouseUpListener = this.renderer.listen('document', 'mouseup', () => {
      this.onMouseUp();
      mouseMoveListener();
      mouseUpListener();
    });
    
    this.renderer.addClass(document.body, 'resizing');
  }
  
  private onMouseMove(event: MouseEvent) {
    if (!this.isResizing) return;
    
    const offset = event.pageX - this.startX;
    let newWidth = this.startWidth + offset;
    
    if (newWidth < 80) newWidth = 80;
    if (newWidth > 500) newWidth = 500;
    
    this.renderer.setStyle(this.headerElement, 'width', `${newWidth}px`);
    this.renderer.setStyle(this.headerElement, 'min-width', `${newWidth}px`);
    this.renderer.setStyle(this.headerElement, 'max-width', `${newWidth}px`);
    
    if (this.resizeColumn) {
      this.resizeColumn.width = `${newWidth}px`;
    }
  }
  
  private onMouseUp() {
    this.isResizing = false;
    this.renderer.removeClass(document.body, 'resizing');
    
    this.saveColumnWidth();
  }
  
  private saveColumnWidth() {
    if (!this.resizeColumn || !this.resizeColumn.prop) return;
    
    const storageKey = `table_column_width_${this.resizeColumn.prop}`;
    const width = this.headerElement.offsetWidth;
    
    localStorage.setItem(storageKey, width.toString());
  }
}